import { render, staticRenderFns } from "./_ticketListReviewAudit.vue?vue&type=template&id=6b45ed80&lang=pug"
import script from "./_ticketListReviewAudit.vue?vue&type=script&lang=js"
export * from "./_ticketListReviewAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports